import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';

import { mq } from '@/utility/mediaQuery';

export const SelectButtonWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: isMobile
      ? [
          'repeat(4, 1fr)',
          'repeat(4, 1fr)',
          'repeat(auto-fit, 112px)',
          'repeat(auto-fit, 112px)',
        ]
      : 'repeat(auto-fit, 120px)',
    gridGap: ['4px 4px', '4px 4px', '8px 8px', '8px 8px'],
    '& > div': {
      width: '100%',
    },
  }),
);
